var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notification_title"},[_vm._v("Mises à jour")]),_vm._l((_vm.notifications),function(item){return _c('Notification',{key:item.id,staticClass:"notification",attrs:{"notification":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }